import React from "react";

import RssIcon from "@uui/Lightning01";

import { FormControlLabel, Typography } from "@mui/material";

import {
  ConnectButton,
  WrapUpCard,
} from "@app/analytics/onboarding/components/styles";
import { CONFERENCING_PLATFORMS_BY_ID } from "@app/common/constants/platforms";
import Config from "@app/config";

import Checkbox from "@rui/Checkbox";
import IconBackground from "@rui/IconBackground";
import InfoPanel from "@rui/InfoPanel";
import Link from "@rui/Link";
import { Column, Row } from "@rui/Stack";
import { Img } from "@rui/styles";

export type WrapUpUpsellType = "connect_zoom" | "rss_extension" | "cx_opt_in";

export const ZoomUpsell = ({ onConnect }: { onConnect: () => void }) => (
  <WrapUpCard>
    <IconBackground
      height={48}
      bgcolor="shades.secondary.50"
      padding={8}
      className="wrap-up-card__icon"
    >
      <Img src={CONFERENCING_PLATFORMS_BY_ID.zoom.icon} height="16px" />
    </IconBackground>
    <Column spacing={1.5} flex={1}>
      <Row spacing={2} variant="apart" flex={1}>
        <Typography variant="bodyPrimaryMed" color="shades.neutral.700">
          Do you use Zoom? Connect it now!
        </Typography>
        <ConnectButton onClick={onConnect} />
      </Row>
      <InfoPanel severity="warning">
        Meeting recap features like summaries, transcripts, and playback will
        not be available for your Zoom meetings if you do not link Read to your
        Zoom account.
      </InfoPanel>
    </Column>
  </WrapUpCard>
);

export const RssExtensionUpsell = () => (
  <WrapUpCard>
    <IconBackground
      height={48}
      bgcolor="shades.secondary.50"
      padding={8}
      className="wrap-up-card__icon"
    >
      <RssIcon sx={{ color: "shades.primary.500" }} />
    </IconBackground>
    <Column spacing={1.5} flex={1}>
      <Row spacing={2} variant="apart" flex={1}>
        <Typography variant="bodyPrimaryMed" color="shades.neutral.700">
          Get the Smart Scheduler Extension
        </Typography>
        <Link href={Config.rss.CHROME_WEB_STORE_URL}>
          <ConnectButton>Add to Chrome</ConnectButton>
        </Link>
      </Row>
      <Typography variant="bodySecondaryReg" color="shades.neutral.600">
        The Read Smart Scheduler Extension integrates seamlessly with Google
        Calendar so you can find the best times to meet, view meeting reports
        and engagement scores, and more - without leaving your calendar!
      </Typography>
    </Column>
  </WrapUpCard>
);

export const CustomerExperienceOptIn = ({
  optedIn,
  onChange,
}: {
  optedIn: boolean;
  onChange: (event: React.SyntheticEvent, checked: boolean) => void;
}) => (
  <FormControlLabel
    control={
      <Checkbox
        checked={optedIn}
        variant="filled"
        sx={{ paddingTop: "2px", paddingRight: "12px" }}
      />
    }
    onChange={onChange}
    label={
      <Typography variant="bodySecondaryReg" color="shades.neutral.800">
        Yes, I want to participate in the Read Customer Experience Program, a
        voluntary program that stores meeting data to help improve the features
        in our service.
      </Typography>
    }
    sx={{ alignItems: "flex-start" }}
  />
);

export const CustomerExperienceOptInUpsell = (props: {
  optedIn: boolean;
  onChange: (event: React.SyntheticEvent, checked: boolean) => void;
}) => (
  <WrapUpCard>
    <CustomerExperienceOptIn {...props} />
  </WrapUpCard>
);
